import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Calendar } from 'lucide-react';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useEnterpriseActivity } from './useEnterpriseActivity';
import { ACTIVITY_ICON, ACTIVITY_TITLE_KEY, formatActivityDateTime } from './utils';

export const RecentActivity = (): ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const { data: activities = [], isLoading } = useEnterpriseActivity();

  return (
    <Card variant="primary" title={t('HomePage.recentActivity.heading')} className="w-full p-0">
      <div className="flex flex-col">
        {isLoading ? (
          <p className="text-denim-800 py-4 text-sm">
            {t('Common.loading', { ns: LOCIZE_NS.COMMON })}
          </p>
        ) : activities.length === 0 ? (
          <p className="text-denim-800 py-4 text-sm">{t('HomePage.recentActivity.empty')}</p>
        ) : (
          activities.map(activity => {
            const Icon = ACTIVITY_ICON[activity.type] ?? Calendar;

            return (
              <div
                key={`${activity.type}-${activity.occurredAt}-${activity.actorEmail ?? ''}`}
                className="border-beige-200 flex gap-3 border-b py-4 first:pt-0 last:border-b-0 last:pb-0"
              >
                <Icon className="text-teal-600 mt-0.5 size-4 shrink-0" aria-hidden />
                <div className="min-w-0 flex-1">
                  <p className="text-denim-800 text-sm leading-4.5 font-medium">
                    {t(ACTIVITY_TITLE_KEY[activity.type])}
                  </p>
                  {activity.actorEmail && (
                    <p className="text-gray-400 mt-1 truncate text-xs leading-4">
                      {activity.actorEmail}
                    </p>
                  )}
                  <p className="text-gray-400 mt-1 text-xs leading-4 font-normal">
                    {formatActivityDateTime(activity.occurredAt)}
                  </p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </Card>
  );
};
